import React from 'react';

interface TextStatsDisplayProps {
  wordCount: number;
  charCount: number;
  deletedChars?: number;
  deletedWords?: number;
  sessionDuration?: number;
  wordsPerMinute?: number;
}

const TextStatsDisplay: React.FC<TextStatsDisplayProps> = ({ 
  wordCount, 
  charCount, 
  deletedChars = 0, 
  deletedWords = 0, 
  sessionDuration = 0,
  wordsPerMinute = 0 
}) => {
  
  const formatTime = (seconds: number): string => {
    if (seconds < 60) return `${seconds}s`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  };
  return (
    <div className="p-5 bg-white dark:bg-gray-800 rounded-lg shadow-lg animate-slide-up delay-300">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Current Stats</h3>
      </div>
      <div className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
        <div className="flex justify-between">
          <span>Words:</span>
          <span className="font-medium">{wordCount}</span>
        </div>
        <div className="flex justify-between">
          <span>Characters:</span>
          <span className="font-medium">{charCount}</span>
        </div>
        <div className="flex justify-between">
          <span>Session Time:</span>
          <span className="font-medium">{formatTime(sessionDuration)}</span>
        </div>
        <div className="flex justify-between">
          <span>Words/Min:</span>
          <span className="font-medium">{wordsPerMinute}</span>
        </div>
        {(deletedChars > 0 || deletedWords > 0) && (
          <>
            <hr className="border-gray-200 dark:border-gray-600" />
            <div className="flex justify-between text-red-600 dark:text-red-400">
              <span>Deleted Words:</span>
              <span className="font-medium">{deletedWords}</span>
            </div>
            <div className="flex justify-between text-red-600 dark:text-red-400">
              <span>Deleted Chars:</span>
              <span className="font-medium">{deletedChars}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TextStatsDisplay; 